import { replaceCurrentRoute } from './utils.js';

var RoutingError;
(function(RoutingError) {
    RoutingError["MISSING_STORE_ID"] = "MISSING_STORE_ID";
    RoutingError["ALTERNATIVE_URL_STORE"] = "ALTERNATIVE_URL_STORE";
    RoutingError["STORE_NOT_FOUND"] = "STORE_NOT_FOUND";
    RoutingError["LINKED_APPOINTMENT_TYPE_NOT_VALID"] = "LINKED_APPOINTMENT_TYPE_NOT_VALID";
    RoutingError["ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID"] = "ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID";
    RoutingError["MISSING_TYPE_ID"] = "MISSING_TYPE_ID";
    RoutingError["TYPE_NOT_FOUND"] = "TYPE_NOT_FOUND";
    RoutingError["TYPE_NOT_AVAILABLE_FOR_STORE"] = "TYPE_NOT_AVAILABLE_FOR_STORE";
    RoutingError["INVALID_VIRTUAL_APPOINTMENT"] = "INVALID_VIRTUAL_APPOINTMENT";
    RoutingError["MISSING_TIMESLOT_START"] = "MISSING_TIMESLOT_START";
    RoutingError["MISSING_TIMESLOT_END"] = "MISSING_TIMESLOT_END";
    RoutingError["MISSING_APPOINTMENT_ID"] = "MISSING_APPOINTMENT_ID";
})(RoutingError || (RoutingError = {}));
const MissingStoreIdError = ()=>new Error(RoutingError.MISSING_STORE_ID)
;
const AlternativeUrlStoreError = ()=>new Error(RoutingError.ALTERNATIVE_URL_STORE)
;
const StoreNotFoundError = ()=>new Error(RoutingError.STORE_NOT_FOUND)
;
const MissingTypeIdError = ()=>new Error(RoutingError.MISSING_TYPE_ID)
;
const TypeNotFoundError = ()=>new Error(RoutingError.TYPE_NOT_FOUND)
;
const TypeNotAvailableForStoreError = ()=>new Error(RoutingError.TYPE_NOT_AVAILABLE_FOR_STORE)
;
const LinkedAppointmentTypeNotValidError = ()=>new Error(RoutingError.LINKED_APPOINTMENT_TYPE_NOT_VALID)
;
const AlternativeLinkedAppointmentTypeNotValidError = ()=>new Error(RoutingError.ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID)
;
const InvalidVirtualAppointmentError = ()=>new Error(RoutingError.INVALID_VIRTUAL_APPOINTMENT)
;
const MissingTimeSlotStartError = ()=>new Error(RoutingError.MISSING_TIMESLOT_START)
;
const MissingTimeSlotEndError = ()=>new Error(RoutingError.MISSING_TIMESLOT_END)
;
const MissingAppointmentIdError = ()=>new Error(RoutingError.MISSING_APPOINTMENT_ID)
;
const routingErrorHandler = (errorMessage, selfUrl, asPath, currentRoute, queryParams)=>{
    switch(errorMessage){
        case RoutingError.STORE_NOT_FOUND:
        case RoutingError.ALTERNATIVE_URL_STORE:
            delete queryParams.storeId;
        case RoutingError.MISSING_STORE_ID:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, '', queryParams)
            };
        case RoutingError.TYPE_NOT_AVAILABLE_FOR_STORE:
            if (currentRoute === '' || currentRoute === 'where') {
                delete queryParams.storeId;
            } else {
                delete queryParams.typeId;
            }
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, [
                    '',
                    'where'
                ].includes(currentRoute) ? currentRoute : 'what', queryParams)
            };
        case RoutingError.LINKED_APPOINTMENT_TYPE_NOT_VALID:
            delete queryParams.linkedAppointmentTypeId;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, currentRoute, queryParams)
            };
        case RoutingError.ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID:
            delete queryParams.alternativeLinkedAppointmentTypeId;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, currentRoute, queryParams)
            };
        case RoutingError.TYPE_NOT_FOUND:
            delete queryParams.typeId;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, [
                    '',
                    'where'
                ].includes(currentRoute) ? currentRoute : 'what', queryParams)
            };
        case RoutingError.MISSING_TYPE_ID:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, 'what', queryParams)
            };
        case RoutingError.INVALID_VIRTUAL_APPOINTMENT:
            delete queryParams.storeId;
            delete queryParams.typeId;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, '', queryParams)
            };
        case RoutingError.MISSING_TIMESLOT_START:
        case RoutingError.MISSING_TIMESLOT_END:
            delete queryParams.start;
            delete queryParams.end;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, 'when', queryParams)
            };
        case RoutingError.MISSING_APPOINTMENT_ID:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, 'who', queryParams)
            };
        default:
            return {
                type: 'not-found'
            };
    }
};

export { AlternativeLinkedAppointmentTypeNotValidError, AlternativeUrlStoreError, InvalidVirtualAppointmentError, LinkedAppointmentTypeNotValidError, MissingAppointmentIdError, MissingStoreIdError, MissingTimeSlotEndError, MissingTimeSlotStartError, MissingTypeIdError, RoutingError, StoreNotFoundError, TypeNotAvailableForStoreError, TypeNotFoundError, routingErrorHandler };
//# sourceMappingURL=errors.js.map
